'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _components2 = require('components');

var _reactBootstrapDatePicker = require('react-bootstrap-date-picker');

var _reactBootstrapDatePicker2 = _interopRequireDefault(_reactBootstrapDatePicker);

var _reactBootstrap = require('react-bootstrap');

require('./Operations.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    OperationsView: {
        displayName: 'OperationsView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Personal/Operations/default/OperationsView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var OperationsView = _wrapComponent('OperationsView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(OperationsView, _Component);

    function OperationsView(props) {
        (0, _classCallCheck3.default)(this, OperationsView);
        return (0, _possibleConstructorReturn3.default)(this, (OperationsView.__proto__ || (0, _getPrototypeOf2.default)(OperationsView)).call(this, props));
    }

    (0, _createClass3.default)(OperationsView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                activeSelect = _props.activeSelect,
                amount = _props.amount,
                count = _props.count,
                balance = _props.balance,
                items = _props.items,
                handleMoreClick = _props.handleMoreClick,
                handleSelect = _props.handleSelect,
                preload = _props.preload,
                morePreload = _props.morePreload,
                lang = _props.lang;


            var dayLabels = [lang['store.common.week.sunday'], lang['store.common.week.monday'], lang['store.common.week.tuesday'], lang['store.common.week.wednesday'], lang['store.common.week.thursday'], lang['store.common.week.friday'], lang['store.common.week.saturday']];
            var monthLabels = [lang['store.common.months.january'], lang['store.common.months.february'], lang['store.common.months.march'], lang['store.common.months.april'], lang['store.common.months.may'], lang['store.common.months.june'], lang['store.common.months.july'], lang['store.common.months.august'], lang['store.common.months.september'], lang['store.common.months.october'], lang['store.common.months.november'], lang['store.common.months.december']];

            return _react3.default.createElement(
                'section',
                { id: 'personal-operations' },
                _react3.default.createElement(
                    'h1',
                    null,
                    lang['store.operations.account_operations']
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-6 col-sm-4 col-md-3 filter_item' },
                        _react3.default.createElement(_reactBootstrapDatePicker2.default, {
                            dateFormat: 'DD.MM.YYYY',
                            dayLabels: dayLabels,
                            monthLabels: monthLabels,
                            onChange: this.props.onChangeBeginDate,
                            showClearButton: false,
                            todayButtonLabel: lang['store.common.today'],
                            value: this.props.begDate,
                            weekStartsOnMonday: true
                        })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-6 col-sm-4 col-md-3 filter_item' },
                        _react3.default.createElement(_reactBootstrapDatePicker2.default, {
                            dateFormat: 'DD.MM.YYYY',
                            dayLabels: dayLabels,
                            monthLabels: monthLabels,
                            onChange: this.props.onChangeEndDate,
                            showClearButton: false,
                            todayButtonLabel: lang['store.common.today'],
                            value: this.props.endDate,
                            weekStartsOnMonday: true
                        })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-4 col-md-3 filter_item' },
                        _react3.default.createElement(
                            'button',
                            { className: 'le-button button_operation', onClick: this.props.onClick },
                            lang['store.common.show']
                        )
                    )
                ),
                _react3.default.createElement(
                    _components2.Preloader,
                    { preload: preload },
                    _react3.default.createElement(
                        'div',
                        null,
                        items.length > 0 ? _react3.default.createElement(
                            'div',
                            { className: 'operations_holder' },
                            _react3.default.createElement(
                                'h2',
                                null,
                                lang['store.operations.operations']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'row no-margin table_head hidden-xs hidden-sm' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-xs-4 no-margin' },
                                    lang['store.common.date_and_time']
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-xs-4 no-margin' },
                                    lang['store.common.sum']
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'col-xs-4 no-margin' },
                                    lang['discount.type']
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                null,
                                items.map(function (item, i) {
                                    return _react3.default.createElement(_components2.OperationsItem, { key: i, item: item, lang: lang });
                                })
                            ),
                            _react3.default.createElement(_components2.Preloader, { preload: morePreload }),
                            items.length < count ? _react3.default.createElement(
                                'div',
                                { className: 'text-center' },
                                _react3.default.createElement(
                                    'span',
                                    { onClick: handleMoreClick, className: 'button_more' },
                                    lang['store.common.show_more']
                                )
                            ) : null
                        ) : _react3.default.createElement(
                            'div',
                            { className: 'operations_holder text-center' },
                            _react3.default.createElement(
                                'h2',
                                null,
                                lang['store.operations.empty']
                            )
                        )
                    )
                )
            );
        }
    }]);
    return OperationsView;
}(_react2.Component), _class.propTypes = {
    activeSelect: _react2.PropTypes.any,
    amount: _react2.PropTypes.array,
    balance: _react2.PropTypes.array,
    begDate: _react2.PropTypes.any,
    count: _react2.PropTypes.number,
    endDate: _react2.PropTypes.any,
    handleMoreClick: _react2.PropTypes.any,
    handleSelect: _react2.PropTypes.func.isRequired,
    items: _react2.PropTypes.array,
    morePreload: _react2.PropTypes.any,
    onChangeBeginDate: _react2.PropTypes.any,
    onChangeEndDate: _react2.PropTypes.func.isRequired,
    onClick: _react2.PropTypes.func.isRequired,
    preload: _react2.PropTypes.any,
    lang: _react2.PropTypes.object
}, _class.defaultProps = {
    amount: [],
    balance: [],
    items: []
}, _temp));

exports.default = OperationsView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Personal/Operations/default/OperationsView.jsx
// module id = 1827
// module chunks = 0